"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var WindowRole = {
  relatedConcepts: [],
  type: 'window'
};
var _default = WindowRole;
exports.default = _default;